/** * * Asynchronously loads the component for
List Page
* */ import { lazyLoad } from "utils/loadable";
export const ListPage = lazyLoad(
  () => import("./index"),
  (module) => module.ListPage
);
